import { render, staticRenderFns } from "./assurCredit.vue?vue&type=template&id=1f375faa&scoped=true"
import script from "./assurCredit.vue?vue&type=script&lang=js"
export * from "./assurCredit.vue?vue&type=script&lang=js"
import style0 from "./assurCredit.vue?vue&type=style&index=0&id=1f375faa&prod&lang=less&scoped=true"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "1f375faa",
  null
  
)

export default component.exports